(function () {
  'use strict';

  function init(root) {
    if (root.getAttribute('data-lbm-ready')) return;
    root.setAttribute('data-lbm-ready', '1');

    var row = root.querySelector('[data-lbm-row]');
    var panel = root.querySelector('[data-lbm-panel]');
    var grid = root.querySelector('[data-lbm-grid]');
    var opener = root.querySelector('[data-lbm-open]');
    var closer = root.querySelector('[data-lbm-close]');
    var arrows = root.querySelector('[data-lbm-arrows]');
    var prev = root.querySelector('[data-lbm-dir="-1"]');
    var next = root.querySelector('[data-lbm-dir="1"]');
    if (!row || !panel || !grid || !opener || !closer) return;

    function updateArrows() {
      var max = row.scrollWidth - row.clientWidth;
      var scrollable = max > 2;
      if (arrows) arrows.hidden = !scrollable;
      if (scrollable && prev && next) {
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max - 2;
      }
    }

    root.querySelectorAll('[data-lbm-dir]').forEach(function (b) {
      b.addEventListener('click', function () {
        touched = true;
        row.scrollBy({ left: Number(b.getAttribute('data-lbm-dir')) * row.clientWidth * 0.8 });
      });
    });
    // Position de defilement gardee d'une page a l'autre (par marque) : la tuile cliquee reste a la meme place.
    // Sans position memorisee (arrivee externe), le modele courant est ramene dans la zone visible.
    var key = 'lbm-scroll:' + (root.getAttribute('data-lbm-key') || '');
    var cur = row.querySelector('[aria-current]');
    var touched = false;
    function restore() {
      if (touched) return;
      var saved = null;
      try { saved = sessionStorage.getItem(key); } catch (e) {}
      var behavior = row.style.scrollBehavior;
      row.style.scrollBehavior = 'auto';
      if (saved !== null) row.scrollLeft = Number(saved) || 0;
      if (cur) {
        var r = row.getBoundingClientRect(), c = cur.getBoundingClientRect();
        if (c.left < r.left || c.right > r.right) row.scrollLeft += c.left - r.left - (r.width - c.width) / 2;
      }
      row.style.scrollBehavior = behavior;
    }
    ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (t) {
      row.addEventListener(t, function () { touched = true; }, { passive: true });
    });
    row.addEventListener('click', function (e) {
      if (!e.target.closest('a.lbm-tile[href]')) return;
      try { sessionStorage.setItem(key, String(Math.round(row.scrollLeft))); } catch (err) {}
    });
    restore();
    if (document.readyState !== 'complete') window.addEventListener('load', restore, { once: true });

    row.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    function fillGrid() {
      if (grid.firstChild) return;
      var frag = document.createDocumentFragment();
      row.querySelectorAll('a.lbm-tile').forEach(function (tile) {
        var cell = tile.cloneNode(true);
        cell.className = 'lbm-cell';
        frag.appendChild(cell);
      });
      grid.appendChild(frag);
    }

    // Fenetre native (<dialog>) : Echap, piege du focus et couche superieure fournis par le navigateur.
    function openPanel() {
      fillGrid();
      if (typeof panel.showModal === 'function') panel.showModal(); else panel.setAttribute('open', '');
      document.documentElement.classList.add('lbm-lock');
      closer.focus({ preventScroll: true });
    }

    function closePanel() {
      if (typeof panel.close === 'function') panel.close(); else { panel.removeAttribute('open'); onClosed(); }
    }

    function onClosed() {
      document.documentElement.classList.remove('lbm-lock');
      opener.focus({ preventScroll: true });
    }

    opener.addEventListener('click', openPanel);
    closer.addEventListener('click', closePanel);
    panel.addEventListener('close', onClosed);
    panel.addEventListener('click', function (e) { if (e.target === panel) closePanel(); }); // clic sur le fond
  }

  function boot() {
    document.querySelectorAll('[data-lbm]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
